import React from 'react';
import CustomMonthYearIndividualDatePicker from '../../../Widgets/CustomDates/CustomMonthYearIndividualDatePicker/CustomMonthYearIndividualDatePicker';
import BiMonthlyPeriodModal from '../../../ClientDetails/Modals/BiMonthlyPeriodModal';
import { FormControlLabel, Switch } from '@mui/material';

const formatDateToYearMonth = (dateString) => {
    const date = new Date(dateString);
    const year = date.getUTCFullYear();
    const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
    return `${year}/${month}`;
};

const VatModalHeader = ({
    t,
    direction,
    isRange,
    isBiMonthly,
    date,
    startDate,
    endDate,
    biStartDate,
    biEndDate,
    showBiMonth,
    setShowBiMonth,
    handleDateChangeNew,
    handleStartDateChangeNew,
    handleEndDateChangeNew,
    handleBiMonthDate,
    handleRangeChange,
    handleDownloadComparativeVat,
    onClose
}) => {
    return (
        <div className="vat-modal-header">
            <div className="vat-modal-header__top-row">
                <h2 className="vat-modal-header__title">{t('VATReport')}</h2>

                <button className="vat-modal-header__comparative-btn" onClick={handleDownloadComparativeVat}>
                    {t('Comparative VAT Report')}
                </button>

                <div className="vat-modal-header__date-section">
                    {isRange ? (
                        <div className="vat-modal-header__range-pickers">
                            <CustomMonthYearIndividualDatePicker
                                year={startDate}
                                month={startDate}
                                onYearChange={(v) => handleStartDateChangeNew(v, 'year', true)}
                                onMonthChange={(v) => handleStartDateChangeNew(v, 'month', true)}
                                labelYear={t("StartYear")}
                                labelMonth={t("StartMonth")}
                                height="36px"
                                widthOuter="200px"
                                widthInner="90px"
                                flip={false}
                            />
                            <div className="vat-modal-header__date-divider" />
                            <CustomMonthYearIndividualDatePicker
                                year={endDate}
                                month={endDate}
                                onYearChange={(v) => handleEndDateChangeNew(v, 'year', true)}
                                onMonthChange={(v) => handleEndDateChangeNew(v, 'month', true)}
                                labelYear={t("EndYear")}
                                labelMonth={t("EndMonth")}
                                height="36px"
                                widthOuter="200px"
                                widthInner="90px"
                                flip={false}
                            />
                        </div>
                    ) : isBiMonthly ? (
                        <>
                            <div
                                className="vat-modal-header__bimonth-display"
                                onClick={() => setShowBiMonth(true)}
                            >
                                <span>{formatDateToYearMonth(biStartDate.toISOString())}</span>
                                <span> - </span>
                                <span>{formatDateToYearMonth(biEndDate.toISOString())}</span>
                            </div>
                            <BiMonthlyPeriodModal
                                visible={showBiMonth}
                                onClose={() => setShowBiMonth(false)}
                                date={biStartDate}
                                t={t}
                                onDateChange={(s, e) => handleBiMonthDate(s, e, true)}
                            />
                        </>
                    ) : (
                        <CustomMonthYearIndividualDatePicker
                            year={date}
                            month={date}
                            onYearChange={(v) => handleDateChangeNew(v, 'year', true)}
                            onMonthChange={(v) => handleDateChangeNew(v, 'month', true)}
                            labelYear={t("Year")}
                            labelMonth={t("Month")}
                            height="36px"
                            widthOuter="200px"
                            widthInner="90px"
                            flip={false}
                        />
                    )}
                </div>

                <button className="vat-modal-header__close-btn" onClick={onClose}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="none">
                        <path d="M15.2501 4.75831C14.9251 4.43331 14.4001 4.43331 14.0751 4.75831L10.0001 8.82498L5.9251 4.74998C5.6001 4.42498 5.0751 4.42498 4.7501 4.74998C4.4251 5.07498 4.4251 5.59998 4.7501 5.92498L8.8251 9.99998L4.7501 14.075C4.4251 14.4 4.4251 14.925 4.7501 15.25C5.0751 15.575 5.6001 15.575 5.9251 15.25L10.0001 11.175L14.0751 15.25C14.4001 15.575 14.9251 15.575 15.2501 15.25C15.5751 14.925 15.5751 14.4 15.2501 14.075L11.1751 9.99998L15.2501 5.92498C15.5668 5.60831 15.5668 5.07498 15.2501 4.75831Z" fill="currentColor" />
                    </svg>
                </button>
            </div>
        </div>
    );
};

export default VatModalHeader;
